'use client'

import React from 'react'
import classNames from 'classnames'

import { FieldErrorsProps } from '@/forms/field-errors/FieldErrors.schema'

import { useTranslations } from '@/lib/context/TranslationsContext'
import { camelizeKebabCase, camelizeSnakeCase, t } from '@/lib/utils/helpers'
import { useLocale } from '@/lib/context/LocaleContext'
import { Translations } from '@/i18n/translations'

const FieldErrors = (props: FieldErrorsProps): JSX.Element => {
    const className = classNames('field-errors', props.className)

    const locale = useLocale()
    const { validationErrors } = useTranslations()

    return (
        <div className={className}>
            {Object.entries(props.fieldErrors).map(([key, value]: [key: string, value: any], index) => {
                let errorMessage: string = ''

                // When the error key is 'message', display the message.
                if (key === 'message') {
                    errorMessage = value[0]
                } else {
                    // When the error key is anything else, search for the translation using the key.
                    const camelizedKey = props.isKebabCase ? camelizeKebabCase(key) : camelizeSnakeCase(key)

                    errorMessage =
                        t(
                            validationErrors[camelizedKey as keyof Translations['validationErrors']],
                            locale,
                            value.variables ?? props.otherVariables
                        ) || ''
                }

                return <p key={index}>{errorMessage}</p>
            })}
        </div>
    )
}

export default FieldErrors
